import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageContainer from 'src/components/container/PageContainer';
import { Box, Button, Grid, IconButton, InputLabel, MenuItem, Pagination, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import ServiceTypeFieldData from './ServiceTypeFieldData';
import DiscountTypeFieldData from './DiscountTypeFieldData';
import SearchImg from '../../assets/search.svg';
import AllPackages from './OurPackages/AllPackages';
import { useLocation } from 'react-router';
// import { ClearIcon } from '@mui/x-date-pickers-pro';
import { MdClear } from "react-icons/md";
import {
  setMemberships,
  setPackages,
  setLoading,
  setPage,
  setLimit,
  setSearch,
  setMembershipType,
  setServices,
  clearFilters
} from '../../redux/slices/membershipSlice';

const AllMemberships = () => {
  const dispatch = useDispatch();
  const {
    filteredMemberships,
    filteredPackages,
    loading,
    pagination,
    packagePagination,
    filters,
    services,
    // clearFilters,
  } = useSelector((state) => state.memberships);
  // const [data, setData] = useState([]);
  // const [membershipType, setMembershipType] = useState('serviceType'); // Default membership type
  // const [showLoader, setShowLoader] = useState(true);
  // const [search, setSearch] = useState('');
  // const [limit, setLimit] = useState(10);
  // const [page, setPage] = useState(1);
  // const [filterData, setFilterData] = useState([]);
  // const [packageData, setPackageData] = useState([]);
  // const [packageFilterData, setPackageFilterData] = useState([]);
  const { fetchAllMemberships, activeBranchId, fetchAllPackages, branchData, getBranch } = useMain();

  const { state } = useLocation();
  const [initialLoad, setInitialLoad] = useState(true);



  const fetchMembershipsData = async (type) => {
    try {
      dispatch(setLoading(true));
      const queryParams = `?membershipType=${type}`;
      const res = await fetchAllMemberships(activeBranchId, queryParams);

      if (res.statusCode === 200) {
        // Add membershipType to each item for filtering
        const dataWithType = res.data.map(item => ({
          ...item,
          membershipType: item.membershipType || type
        }));
        dispatch(setMemberships(dataWithType));
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
      setInitialLoad(false);
    }
  };


  // Fetch packages data (for packageType)
  const fetchPackagesData = async () => {
    try {
      dispatch(setLoading(true));
      const res = await fetchAllPackages(activeBranchId);

      if (res.statusCode === 200) {
        // Add packageType to each item for consistency
        const dataWithType = res.data.map(item => ({
          ...item,
          membershipType: 'packageType'
        }));
        dispatch(setPackages(dataWithType));
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
      setInitialLoad(false);
    }
  };

  // Initial load - fetch only serviceType memberships
  useEffect(() => {
    if (activeBranchId) {
      if (filters.membershipType === 'packageType') {
        fetchPackagesData();
      } else {
        fetchMembershipsData(filters.membershipType);
      }
    }
  }, [activeBranchId, filters.membershipType]);



  const handleMembershipTypeChange = (event, newMembershipType) => {
    if (newMembershipType && newMembershipType !== filters.membershipType) {
      dispatch(setMembershipType(newMembershipType));
      dispatch(setSearch(''));
      dispatch(setLimit(10));
      dispatch(setPage(1));

      // Fetch appropriate data based on type
      if (newMembershipType === 'packageType') {
        fetchPackagesData();
      } else {
        fetchMembershipsData(newMembershipType);
      }
    }
  };


  useEffect(() => {
    if (activeBranchId && filters.membershipType === 'serviceType') {
      const getData = async () => {
        try {
          const res = await getBranch(activeBranchId);
          dispatch(setServices(res?.data.services || []));
        } catch (error) {
          console.error("Error fetching branch services:", error);
        }
      };
      getData();
    }
  }, [activeBranchId, filters.membershipType]);

  // Reset filters when component mounts
  useEffect(() => {
    dispatch(clearFilters());

    // Cleanup function to reset filters when component unmounts
    return () => {
      dispatch(clearFilters());
    };
  }, [dispatch]);
    const handleSearchChange = (e) => {
    dispatch(setSearch(e.target.value.trimStart()));
  };

  // Inserts the pasted text at the cursor, then trims the final value
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text');
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(setSearch(next));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(setSearch(trimmed));
    }
  };



  return (
    <PageContainer title="Manage Membership" description="This contains all products">
      <DashboardCard2 title="Manage Membership">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr auto' }}>
          <div style={{ marginBottom: '1.7rem' }}>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{ borderRadius: '7px', border: '0.5px solid #6174DD', padding: '4px 12px', background: '#FFF', height: '40px', width: '10%' }}
              value={pagination.limit}
              onChange={(e) => dispatch(setLimit(e.target.value))}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
                             <MenuItem value={1000000}>All</MenuItem>

            </Select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', width: '76%' }} onClick={() => document.getElementById('search-input').focus()}>
            <div style={{ marginBottom: '1rem' }}>
              <InputLabel>Search</InputLabel>
              <div className="search-input" style={{width:'170px', display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                <img src={SearchImg} alt="" />
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search Membership/Packages..."
                  value={filters.search || ''}
                  onChange={handleSearchChange}
                  onPaste={handleSearchPaste}
                  onBlur={handleSearchBlur}
                  style={{ marginLeft: '0.5rem' }}
                />
                {filters.search && (
                  <IconButton
                    onClick={() => dispatch(setSearch(''))}
                    style={{ padding: 1 }}
                  >
                    <MdClear style={{
                      color: '#000',
                      marginRight: '-0.2rem', marginTop: '0.1rem',
                      fontSize: '1.1rem'
                    }} />
                  </IconButton>
                )}
              </div>
            </div>
          </div>


          <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '1.5rem 4rem',
            width: '100%'
          }}>
            <ToggleButtonGroup
              value={filters.membershipType}
              exclusive
              onChange={handleMembershipTypeChange}
              sx={{
                width: '90%',
                maxWidth: '600px',
                backgroundColor: 'transparent',
                gap: '8px',
                '& .MuiToggleButtonGroup-grouped': {
                  border: 0,
                  '&:not(:first-of-type)': {
                    borderRadius: '8px',
                    marginLeft: '0px'
                  },
                  '&:first-of-type': {
                    borderRadius: '8px'
                  }
                }
              }}
            >
              {[
                { value: 'serviceType', label: 'Service Membership' },
                { value: 'discountType', label: 'Discount Membership' },
                { value: 'packageType', label: 'All Packages' }
              ].map(({ value, label }) => (
                <ToggleButton
                  key={value}
                  value={value}
                  sx={{
                    flex: 1,
                    py: 1.5,
                    px: 2,
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: '#4A4A4A',
                    backgroundColor: '#F5F5F5',
                    border: '1px solid #E0E0E0',
                    borderRadius: '8px !important',
                    transition: 'all 0.3s ease',
                    '&.Mui-selected, &.Mui-selected:hover': {
                      color: '#FFFFFF',
                      backgroundColor: '#6174DD',
                      borderColor: '#6174DD',
                      boxShadow: '0 2px 8px rgba(97, 116, 221, 0.3)'
                    },
                    '&:hover': {
                      backgroundColor: '#E8EAF6',
                      borderColor: '#D1D5F0'
                    },
                    '&:not(:last-child)': {
                      marginRight: '8px'
                    }
                  }}
                >
                  {label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>

        </div>

        {loading ? (
          <ShowLoader />
        ) : filters.membershipType === 'serviceType' ? (
          filteredMemberships.length > 0 ? (
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <ServiceTypeFieldData
                    data={filteredMemberships}
                    state={state}
                    branchData={branchData}
                    services={services}
                    search={(filters.search || '').trim() }
                   />
                    
                </Grid>
              </Grid>
            </Box>
          ) : (
            'No data found'
          )
        ) : filters.membershipType === 'discountType' ? (
          filteredMemberships.length > 0 ? (
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <DiscountTypeFieldData
                    data={filteredMemberships}
                    state={state}
                    branchData={branchData}
                   search={(filters.search || '').trim()}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            'No data found'
          )
        ) : filters.membershipType === 'packageType' ? (
          filteredPackages.length > 0 ? (
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <AllPackages
                    data={filteredPackages}
                    state={state}
                    branchData={branchData}
                    search={(filters.search || '').trim() }
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            'No data found'
          )
        ) : null}

        {filters.membershipType === 'packageType' ? (
          filteredPackages.length > 0 && (
            <Grid container justifyContent="end">
              <Pagination
                count={Math.ceil(packagePagination.total / packagePagination.limit)}
                color="primary"
                page={packagePagination.page}
                onChange={(e, value) => dispatch(setPage(value))}
              />
            </Grid>
          )
        ) : (
          filteredMemberships.length > 0 && (
            <Grid container justifyContent="end">
              <Pagination
                count={Math.ceil(pagination.total / pagination.limit)}
                color="primary"
                page={pagination.page}
                onChange={(e, value) => dispatch(setPage(value))}
              />
            </Grid>
          )
        )}
      </DashboardCard2>
    </PageContainer>
  );
};

export default AllMemberships;